const initialState = {
  user_detail: {},
  toggle_header: false,
};

export default initialState;
